import { StyledDateInput } from "./date-input.style";
import { IMDSDateInputProps } from "./date-input.types";

export function MDSDateInput(props: IMDSDateInputProps) {
  return <StyledDateInput {...props} />;
}
